<template>
  <div class="quality-selector" :class="{ compact }" role="group" aria-label="选择图片生成质量">
    <span v-if="showLabel" class="quality-selector__label">质量</span>
    <div class="quality-selector__options">
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        :class="{ active: normalizedValue === option.value }"
        :disabled="disabled"
        :aria-pressed="String(normalizedValue === option.value)"
        :aria-label="showValue ? `${option.label} ${option.value}，每次 ${option.points} 积分。${option.description}` : `${option.label}，每次 ${option.points} 积分。${option.description}`"
        :title="option.description"
        @click="$emit('input', option.value)"
      >
        <strong>{{ option.label }}</strong>
        <small>{{ showValue ? `${option.value} · ` : '' }}{{ option.points }}积分</small>
      </button>
    </div>
  </div>
</template>

<script>
import { DEFAULT_GENERATION_QUALITY, GENERATION_QUALITY_OPTIONS, normalizeGenerationQuality } from '@/utils/outputQuality'

export default {
  name: 'QualitySelector',
  props: {
    value: { type: String, default: DEFAULT_GENERATION_QUALITY },
    disabled: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
    showLabel: { type: Boolean, default: true },
    showValue: { type: Boolean, default: true }
  },
  data() {
    return { options: GENERATION_QUALITY_OPTIONS }
  },
  computed: {
    normalizedValue() { return normalizeGenerationQuality(this.value) }
  }
}
</script>

<style scoped>
.quality-selector{display:inline-flex;align-items:center;gap:9px;max-width:100%}.quality-selector__label{color:#606d65;font-size:10px;font-weight:700;white-space:nowrap}.quality-selector__options{display:inline-grid;grid-template-columns:repeat(2,minmax(80px,1fr));gap:5px}.quality-selector button{min-height:38px;display:flex;align-items:flex-start;justify-content:center;flex-direction:column;border:1px solid #d9e0dc;border-radius:7px;padding:5px 9px;background:#fff;color:#556159;text-align:left;cursor:pointer;transition:border-color .18s ease,background .18s ease,box-shadow .18s ease}.quality-selector button:hover:not(:disabled){border-color:#8facdf;background:#f7faff}.quality-selector button:focus-visible{outline:2px solid #2563eb;outline-offset:2px}.quality-selector button.active{border-color:#2563eb;background:#edf4ff;color:#1f58b7;box-shadow:inset 0 0 0 1px rgba(37,99,235,.16)}.quality-selector button:disabled{cursor:not-allowed;opacity:.58}.quality-selector strong{font-size:10px;line-height:1.2}.quality-selector small{margin-top:2px;color:#849087;font-size:8px;line-height:1.2;white-space:nowrap}.quality-selector button.active small{color:#5576ae}.quality-selector.compact{gap:7px}.quality-selector.compact .quality-selector__options{grid-template-columns:repeat(2,minmax(70px,1fr))}.quality-selector.compact button{min-height:34px;padding:4px 7px}.quality-selector.compact small{font-size:7px}@media(max-width:767px){.quality-selector{width:100%;justify-content:space-between}.quality-selector__options{min-width:0;flex:1}.quality-selector button,.quality-selector.compact button{min-height:44px}.quality-selector strong{font-size:12px}.quality-selector small,.quality-selector.compact small{font-size:9px}}
</style>
